export default __webpack_public_path__ + "static/media/sabah-logo.176fc9d6.png";